import React from 'react'

import './content.css'

function FullContent({contentArray}) {
    var fullContent = <></>

    for (var content in contentArray) {
        fullContent = fullContent + content
    }

    return fullContent
}

export default FullContent